import React, { useState } from 'react';
import { supabase } from '../../lib/supabase';
import { passwordProblem, PASSWORD_HINT } from '../../lib/passwordPolicy';
import { T } from '../shared/constants';

// Shown when a parent opens a password-reset link. Supabase signs them in with a short-lived recovery session and fires
// PASSWORD_RECOVERY; until now the app ignored that event, so the link signed them in without ever asking for a new
// password. This screen sets it with supabase.auth.updateUser.
export default function SetNewPassword({ email, onDone }) {
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  async function save(e) {
    e?.preventDefault?.();
    setError('');
    const problem = passwordProblem(pw, email);
    if (problem) { setError(problem); return; }
    if (pw !== pw2) { setError("The two passwords don't match."); return; }
    setBusy(true);
    try {
      const res = await supabase.auth.updateUser({ password: pw });
      const err = res?.error;
      if (err) { setError(err.message || 'Could not update your password. Please try the reset link again.'); return; }
      setDone(true);
    } finally { setBusy(false); }
  }

  const input = { width: '100%', padding: '12px 14px', border: `1.5px solid ${T.border}`, borderRadius: 12, fontSize: 15,
    fontFamily: "'Plus Jakarta Sans',sans-serif", boxSizing: 'border-box', marginBottom: 12, background: T.surface, color: T.text };
  return (
    <div style={{ minHeight: '100vh', background: T.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <form onSubmit={save} style={{ width: '100%', maxWidth: 420, background: T.card, border: `1px solid ${T.border}`, borderRadius: 20, padding: '28px 26px', boxShadow: '0 8px 40px rgba(0,0,0,.06)' }}>
        <h1 style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 28, color: T.text, margin: '0 0 6px' }}>Set a new password</h1>
        {done ? (
          <>
            <p style={{ fontSize: 14, color: T.textMid, lineHeight: 1.6, margin: '0 0 18px' }}>Your password has been changed. You're signed in.</p>
            <button type="button" onClick={onDone} style={{ width: '100%', padding: 13, background: T.accent, color: 'white', border: 'none', borderRadius: 12, fontWeight: 700, fontSize: 15, cursor: 'pointer' }}>Continue to Empirio</button>
          </>
        ) : (
          <>
            <p style={{ fontSize: 13, color: T.textMid, lineHeight: 1.6, margin: '0 0 16px' }}>{email ? `For ${email}. ` : ''}{PASSWORD_HINT}</p>
            <input type="password" autoComplete="new-password" placeholder="New password" aria-label="New password" value={pw} onChange={(e) => setPw(e.target.value)} style={input} />
            <input type="password" autoComplete="new-password" placeholder="Type it again" aria-label="Confirm new password" value={pw2} onChange={(e) => setPw2(e.target.value)} style={input} />
            {error && <p role="alert" style={{ color: T.red, fontSize: 13, margin: '0 0 12px' }}>{error}</p>}
            <button type="submit" disabled={busy} style={{ width: '100%', padding: 13, background: T.accent, color: 'white', border: 'none', borderRadius: 12, fontWeight: 700, fontSize: 15, cursor: busy ? 'default' : 'pointer', opacity: busy ? 0.7 : 1 }}>{busy ? 'Saving…' : 'Save new password'}</button>
          </>
        )}
      </form>
    </div>
  );
}
